<div class="container-fluid py-4 production-container">
    <!-- Detail View (when viewing a single production) -->
    <div *ngIf="productions.length === 1 && encryptedId; else listView">
        <div class="row mb-4">
            <div class="col-12">
                <button class="btn btn-secondary" (click)="router.navigate(['/main/production'])">
                    <i class="bi bi-arrow-left me-2"></i>Back to Productions
                </button>
            </div>
        </div>

        <div class="row" *ngIf="productions[0]">
            <div class="col-lg-10 mx-auto">
                <div class="card shadow-lg border-0 rounded-4 glass-card">
                    <div class="card-header bg-primary text-white">
                        <h2 class="mb-0">Audition Details</h2>
                    </div>
                    <div class="card-body p-4">
                        <!-- View Mode -->
                        <div class="details-grid">
                            <div class="detail-item">
                                <span class="detail-label">Name</span>
                                <span class="detail-value">{{ productions[0].firstName }} {{ productions[0].lastName
                                    }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">Email</span>
                                <span class="detail-value">{{ productions[0].email }}</span>
                            </div>

                            <div class="detail-item">
                                <span class="detail-label">Phone</span>
                                <span class="detail-value">{{ productions[0].phoneNumber }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">Additional Phone</span>
                                <span class="detail-value">{{ productions[0].additionalPhoneNumber || 'N/A' }}</span>
                            </div>

                            <div class="detail-item">
                                <span class="detail-label">Address</span>
                                <span class="detail-value">{{ productions[0].address || 'N/A' }}</span>
                            </div>

                            <div class="detail-item">
                                <span class="detail-label">City</span>
                                <span class="detail-value">{{ productions[0].city || 'N/A' }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="detail-label">State</span>
                                <span class="detail-value">{{ productions[0].state || 'N/A' }}</span>
                            </div>

                            <div class="detail-item">
                                <span class="detail-label">Country</span>
                                <span class="detail-value">{{ productions[0].country || 'N/A' }}</span>
                            </div>

                            <div class="detail-item">
                                <span class="detail-label">Dance Style</span>
                                <span class="detail-value">{{ productions[0].danceStyle || 'N/A' }}</span>
                            </div>

                            <div class="detail-item">
                                <span class="detail-label">Google Drive Link</span>
                                <span class="detail-value"> <a
                                        [href]="productions[0].googleDriveLink"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                >
                                    Open Link
                                </a></span>
                            </div>

                            <div class="detail-item full-width">
                                <span class="detail-label">Description</span>
                                <span class="detail-value text-muted">{{ productions[0].description || 'N/A' }}</span>
                            </div>

                            <!--<div class="detail-item full-width">
                                <span class="detail-label">Performance Video</span>
                                <span class="detail-value">
                                    <button *ngIf="productions[0].performanceVideoPath; else noVideo"
                                        class="btn btn-sm btn-outline-primary"
                                        (click)="downloadVideo(productions[0].auditionCallRegSeq)">
                                        <i class="bi bi-download me-2"></i>Download Video
                                    </button>
                                    <ng-template #noVideo>N/A</ng-template>
                                </span>
                            </div>-->
                            <div class="detail-item">
                                <span class="detail-label">Submitted Date</span>
                                <span class="detail-value">{{ productions[0].createdAt | date:'medium' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- List View -->
    <ng-template #listView>
        <div class="text-center mb-4">
            <h2 class="title">Production Details</h2>
            <p class="subtitle">Overview of all registered productions</p>
        </div>

        <div class="card shadow-lg border-0 rounded-4 glass-card">
            <div class="table-scroll-wrapper">
                <table class="table table-hover align-middle stylish-table mb-0">
                    <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th class="text-center">Name</th>
                            <th class="text-center">Phone</th>
                            <th class="text-center">City</th>
                            <th class="text-center">Email</th>
                            <th class="text-center">Drive Link</th>
                            <th class="text-center">View</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let production of productions; let i = index">
                            <td class="fw-bold text-center">{{ i + 1 }}</td>
                            <td class="text-center">{{ production.firstName }} {{ production.lastName }}</td>
                            <td class="text-center">{{ production.phoneNumber }}</td>
                            <td class="text-center">{{ production.city }}</td>
                            <td class="text-center">{{ production.email }}</td>
                            <td class="text-center">
                                <a
                                        [href]="production.googleDriveLink"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                >
                                    Open Link
                                </a>
                            </td>
                            <td class="text-center">
                                <i class="bi bi-eye icon-action text-success" title="View Details"
                                    (click)="viewProduction(production.auditionCallRegSeq)"></i>
                            </td>
                        </tr>

                        <tr *ngIf="productions.length === 0">
                            <td colspan="7" class="text-center text-muted py-4">No productions found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-template>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>